
import {
  Box,
  Typography,
  Avatar,
} from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import PhoneIcon from '@mui/icons-material/Phone';
import { heritageColors } from '../../../../heritageTheme.ts';

const Grid = ({ initialData = { contacts: [] }, title = 'אנשי קשר והנהלה', showTitle = true }) => {
  const contacts = initialData.contacts || [];

  const getInitial = (name) => {
    return name ? name.charAt(0) : '?';
  };

  return (
    <Box sx={{ p: 3, direction: 'rtl' }}>
      {/* Header */}
      {showTitle && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
          <GroupsIcon sx={{ color: heritageColors.navy, fontSize: 24 }} />
          <Typography variant="h5" sx={{ color: heritageColors.navy, fontWeight: 700 }}>
            {title}
          </Typography>
        </Box>
      )}

      {/* Contacts Grid */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: 2,
        flexWrap: 'wrap',
      }}>
        {contacts.map((contact) => (
          <Box
            key={contact.id}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 1,
              minWidth: 80,
            }}
          >
            <Avatar
              sx={{
                width: 56,
                height: 56,
                bgcolor: heritageColors.navy,
                fontSize: '1.25rem',
                fontWeight: 700,
              }}
            >
              {getInitial(contact.name)}
            </Avatar>
            <Typography sx={{
              fontWeight: 600,
              color: heritageColors.navy,
              fontSize: '0.9rem',
            }}>
              {contact.name}
            </Typography>
            <Typography sx={{
              fontSize: '0.8rem',
              color: heritageColors.slate,
            }}>
              {contact.role}
            </Typography>
            {contact.phone && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <PhoneIcon sx={{ fontSize: 14, color: heritageColors.gold }} />
                <Typography sx={{
                  fontSize: '0.75rem',
                  color: heritageColors.gold,
                }}>
                  {contact.phone}
                </Typography>
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Grid;